import type { PostInputMetaData } from '../../graphqlTypes'
import type { Draft } from '~publish/legacy/composer/composer/entities/Draft'

import {
  getChannelVariantLinkAttachment,
  mapChannelVariantThread,
} from '../../channelVariantToCreatePostInput'
import {
  ensureLinkAttachmentProtocol,
  mapLinkAttachment,
} from '../../mapAssets'
import { mapThread } from '../../mapThread'
import type { MapperContext } from '../../types'
import { clearable } from '../shared/clearable'
import type { ServiceMapperEntry } from '../types'

// Bluesky has no per-channel data — only the thread and the link attachment,
// each tri-stated via `clearable`: omitted on create, `null` on edit to
// clear it.
//
// `ctx.channelVariant` (when present) supplies both fields.
export function mapBluesky(
  draft: Draft,
  ctx: MapperContext,
): PostInputMetaData {
  const variant = ctx.channelVariant
  const thread = variant
    ? mapChannelVariantThread(variant.threadItems, 'bluesky')
    : mapThread(draft)
  const linkAttachment = variant
    ? getChannelVariantLinkAttachment(variant)
    : mapLinkAttachment(draft)

  return {
    bluesky: {
      thread: clearable(thread, ctx),
      linkAttachment: clearable(
        linkAttachment && ensureLinkAttachmentProtocol(linkAttachment),
        ctx,
      ),
    },
  }
}

export const bluesky: ServiceMapperEntry = {
  mapper: mapBluesky,
}
